export default __webpack_public_path__ + "static/media/web.58eee0ea.svg";